import React from 'react'
import { connect } from 'react-redux'
import { history } from 'store/store'
import { localized, withPersistence, withDialogs } from 'decorators'
import { ListPage } from 'components/page'
import { listActionProps } from 'utils/gridActions'
import { assertMetadata } from 'utils/assertMetadata'
import 'polyfills/distinct'

const createListPage = ({ metadata, actionCreators, api, Content, AboveContent }) => {
  assertMetadata(metadata)
  const CommonListPage = (props) => {
    const { showDialog, persistor } = props
    const handleOnRowClick = React.useCallback((e, selectedIds = [], isMultiselectEnabled) => {

      const ids = [...selectedIds, e.dataItem.id].distinct()

      if ((isMultiselectEnabled && metadata.useDetailDialog === true) || ids.length > 1) {
        showDialog({
          dialogType: metadata.detailDialog,
          context: {
            entity: e.dataItem,
            selectedIds: ids
          }
        })
      } else {
        history.push(`${metadata.urls.base}/${e.dataItem.id}`)
      }
    }, [showDialog, metadata.useDetailDialog])
    return (
      <ListPage metadata={metadata} aboveContent={AboveContent}>
        <Content
          key={props[metadata.page].gridKey}
          dataSource={api.get}
          metadata={metadata}
          persistor={props.persistor}
          onRowClick={handleOnRowClick}
          actionProps={listActionProps(props)} />
      </ListPage>
    )
  }

  return connect(
    (state) => ({ [metadata.page]: state[metadata.page] }),
    { delete: actionCreators.delete })(withDialogs(withPersistence(`page:${metadata.page}`, localized(CommonListPage))))
}

export {
  createListPage
}
